import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxVodResponse } from '../../../entity/interface/iMpxVodResponse';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';

export interface IGetSeriesUseCase {
    execute(feed: string | null, filters: { [key: string]: string | number | boolean }): Promise<IMpxVodResponse>;
}
export class GetSeriesUseCase implements IGetSeriesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        feed: string | null,
        filters: { [key: string]: string | number | boolean }
    ): Promise<IMpxVodResponse> {
        return this.mpxRepository.getSeries(feed, filters);
    }
}
